// extracted by mini-css-extract-plugin
export default {"slider":"ToggleButton_slider__ZatnZ","switch":"ToggleButton_switch__CLXLI","switchInput":"ToggleButton_switchInput__jSf5e"};